import { css } from '@emotion/core';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import Icon from '@veeva/corgix/icon';
import PropTypes from 'prop-types';
import useMessageService from '../../services/i18n/useMessageService';
import colors from '../../theme/colors';
import InputField from '../InputField';
import getTargetAttribute from '../../services/getTargetAttribute';

const propTypes = {
    error: PropTypes.bool,
    errorMessage: PropTypes.node,
    hideIcon: PropTypes.bool,
    label: PropTypes.string,
    onChange: PropTypes.func,
    onKeyUp: PropTypes.func,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const EmailField = ({
    error,
    errorMessage,
    hideIcon = false,
    label,
    onChange,
    onKeyUp,
    placeholder,
    readOnly = false,
    value,
}) => {
    const [[emailAddressLabel = 'Email Address']] = useMessageService(['general.email_address']);

    const handleSubmit = (e) => {
        if (e.code === 'Enter') {
            onKeyUp?.();
        }
    };

    const handleChange = (email) => {
        onChange?.(email?.trim());
    };

    return (
        <InputField
            id="email-field"
            css={css`
                width: 100%;
            `}
            error={error}
            errorMessage={errorMessage}
            label={label}
            placeholder={placeholder || emailAddressLabel}
            onChange={handleChange}
            onKeyUp={handleSubmit}
            readOnly={readOnly}
            renderIcons={() => {
                return hideIcon ? null : (
                    <Icon
                        className="prepend"
                        color={value ? null : colors.lightGray}
                        size="md"
                        type={faEnvelope}
                    />
                );
            }}
            type="text"
            value={value}
            data-target={getTargetAttribute('email-field')}
        />
    );
};

EmailField.propTypes = propTypes;
export default EmailField;
